module.exports = __webpack_public_path__ + "static/media/raghav_pahwa.25549b18.jpg";